export default __webpack_public_path__ + "static/media/user-icon.c2546c9d.svg";